
export const environment = {
  env: 'qa',
  production: false,
  oidc: {
    clientId: '0oa9nzm55muoLBP2r4h7',
    issuer: 'https://relayhealth.okta.com/oauth2/aus95ynd1xJvRSJ8N4h7',
    redirectUri: 'login/callback',
    scopes: ['openid'],
    pkce: false
  },
  authPrefix: 'NPE',
  authGroup: 'SmartHopUI-Users',
  appUrl: 'https://smarthop-config-qa.relayhealth.com',
  apiUrl: 'https://smarthop-config-api-qa.relayhealth.com'
};
